export default __webpack_public_path__ + "static/media/classified.7db47633.webp";